import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustSignals = () => {
  const certifications = [
    {
      name: "RV Industry Association",
      description: "Certified RV Park Investment Advisor",
      icon: "Award",
      verified: true
    },
    {
      name: "National Association of RV Parks",
      description: "Trusted Financial Planning Partner",
      icon: "Shield",
      verified: true
    },
    {
      name: "SSL Secured",
      description: "Your data is protected with 256-bit encryption",
      icon: "Lock",
      verified: true
    }
  ];

  const testimonials = [
    {
      name: "Sarah Johnson",
      location: "Colorado Springs, CO",
      text: "The projections were incredibly accurate. We\'re now generating 15% more revenue than initially projected!",
      rating: 5,
      parkType: "Mountain View RV Resort"
    },
    {
      name: "Mike Rodriguez",
      location: "Austin, TX",
      text: "This calculator helped us secure financing and plan our expansion. The strategic recommendations were spot-on.",
      rating: 5,
      parkType: "Lakeside RV Park"
    }
  ];

  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, i) => (
      <Icon
        key={i}
        name="Star"
        size={14}
        className={i < rating ? "text-accent fill-current" : "text-muted-foreground"}
      />
    ));
  };

  return (
    <div className="space-y-6">
      {/* Certifications */}
      <div className="bg-card border border-border rounded-lg p-6 shadow-sm">
        <h3 className="font-heading font-bold text-lg text-foreground mb-4">
          Industry Certifications
        </h3>
        <div className="space-y-4">
          {certifications?.map((cert, index) => (
            <div key={index} className="flex items-start space-x-3">
              <div className="flex items-center justify-center w-8 h-8 bg-success/10 rounded-lg flex-shrink-0">
                <Icon name={cert?.icon} size={16} className="text-success" />
              </div>
              <div className="flex-1">
                <div className="flex items-center space-x-2">
                  <h4 className="font-heading font-semibold text-sm text-foreground">
                    {cert?.name}
                  </h4>
                  {cert?.verified && (
                    <Icon name="CheckCircle2" size={14} className="text-success" />
                  )}
                </div>
                <p className="font-body text-xs text-muted-foreground mt-1">
                  {cert?.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Testimonials */}
      <div className="bg-card border border-border rounded-lg p-6 shadow-sm">
        <h3 className="font-heading font-bold text-lg text-foreground mb-4">
          Success Stories
        </h3>
        <div className="space-y-4">
          {testimonials?.map((testimonial, index) => (
            <div key={index} className="border-l-4 border-primary pl-4">
              <div className="flex items-center space-x-1 mb-2">
                {renderStars(testimonial?.rating)}
              </div>
              <blockquote className="font-body text-sm text-foreground italic mb-3">
                "{testimonial?.text}"
              </blockquote>
              <div className="flex items-center justify-between">
                <div>
                  <p className="font-heading font-semibold text-sm text-foreground">
                    {testimonial?.name}
                  </p>
                  <p className="font-body text-xs text-muted-foreground">
                    {testimonial?.parkType} • {testimonial?.location}
                  </p>
                </div>
                <Icon name="Quote" size={20} className="text-muted-foreground opacity-50" />
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Security Badge */}
      <div className="bg-muted/30 border border-border rounded-lg p-4 text-center">
        <div className="flex items-center justify-center space-x-2 mb-2">
          <Icon name="Shield" size={20} className="text-success" />
          <span className="font-heading font-semibold text-sm text-foreground">
            Secure & Confidential
          </span>
        </div>
        <p className="font-body text-xs text-muted-foreground">
          Your financial data is encrypted and never shared with third parties
        </p>
      </div>
    </div>
  );
};

export default TrustSignals;